// extracted by mini-css-extract-plugin
export var active = "_10-8";
export var addWidgetButton = "_10-9";
export var backButton = "_10-1";
export var pageContainer = "_10-2";
export var settingsContent = "_10-0";
export var sideNavContainer = "_10-6";
export var sideNavLink = "_10-7";
export var widgetContainer = "_10-5";
export var widgetSubsectionItem = "_10-3";
export var widgetSubsectionItemContent = "_10-4";